import { useEffect, useRef, useState } from 'react'
import { WppActionButton, WppIconAdd, WppIconChevron } from '@wppopen/components-library-react'
import { Swiper, SwiperClass } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import clsx from 'clsx'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import styles from './TabsCarousel.module.scss'

interface TabsCarouselProps {
  children: React.ReactNode
  className?: string
  isActiveButton?: boolean
  onPlusClick?: () => void
  permissions?: {
    canPostProjectRegion: boolean
  }
}

export default function TabsCarousel({
  children,
  className,
  isActiveButton,
  onPlusClick,
  permissions,
}: TabsCarouselProps) {
  const swiperRef = useRef<SwiperClass>()
  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  const handleSlideChange = () => {
    if (swiperRef.current) {
      setIsBeginning(swiperRef.current.isBeginning)
      setIsEnd(swiperRef.current.isEnd)
    }
  }

  // Effect to update swiper when children change
  useEffect(() => {
    handleSlideChange()
    if (swiperRef.current) {
      swiperRef.current.update() // Update swiper to account for new slides
    }
  }, [children])

  return (
    <div className={clsx(styles.tabContainer, className)}>
      {permissions?.canPostProjectRegion && onPlusClick && (
        <WppActionButton aria-label="add-new-slide" onClick={onPlusClick}>
          <WppIconAdd slot="icon-start" />
        </WppActionButton>
      )}

      <Swiper
        onBeforeInit={swiper => {
          swiperRef.current = swiper
        }}
        slidesPerView="auto"
        modules={[Navigation]}
        className={clsx('mySwiper', styles.swiperContainer)}
      >
        {children}
      </Swiper>

      {isActiveButton && (
        <>
          <WppIconChevron
            onClick={() => {
              swiperRef.current?.slidePrev()
              handleSlideChange()
            }}
            role="button"
            direction="left"
            data-testid="swipe-left-button"
            className={clsx(isBeginning && styles.inactiveButton)}
          />
          <WppIconChevron
            onClick={() => {
              swiperRef.current?.slideNext()
              handleSlideChange()
            }}
            role="button"
            direction="right"
            data-testid="swipe-right-button"
            className={clsx(isEnd && styles.inactiveButton)}
          />
        </>
      )}
    </div>
  )
}
